<template>
  <div style="padding: 32px 15px" class="starter-main mycontainer">
    <!-- <HeaderPage
      :title="header.title"
      :list="header.list"
      :image="header.image"
      :tipe_gambar="header.tipe"
    /> -->
    <div class="row">
      <div class="col-8">
        <div class="card">
          <div class="card-header padding_12_20">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <div class="me-3">
                  <img src="@/assets/images/a/human_capital.svg" />
                </div>
                <div>
                  <div class="card_title_1">HUMAN CAPITAL</div>
                  <div class="card_title_2">
                    Last Updated {{ last_update.human }}
                  </div>
                </div>
              </div>
              <div>
                <select v-model="instanceId" class="form-select custom_select">
                  <option
                    v-for="(option, key) in dataInstance"
                    :key="key"
                    :value="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="card-body padding_20">
            <!-- <div class="row">
              <div class="col">
                <AlertVue :text="alert_human" :type="'danger'" />
              </div>
            </div> -->
            <div class="row">
              <div class="col-6">
                <div class="sub_title_1">PRODUCTIVITY</div>
                <Productivity :data="product" :load="load" />
                <div class="sub_title_1">EXCELLENCE & PROFESSIONALISM</div>
                <Excellence
                  :datas="excellence"
                  :load="load"
                  :chart_digital="digital"
                />
                <div class="sub_title_1">EFFICIENCY</div>
                <Efficiency :datas="dataEffeciency" :load="load" />
              </div>
              <div class="col-6">
                <div class="sub_title_1">OCCUPATIONAL HEALTH AND SAFETY</div>
                <Occupational :datas="occupational" :load="load" />
                <div class="sub_title_1 mb-0">ORGANIZATIONAL HEALTH</div>
                <div class="sub_title_blue">
                  Organizational health metrics are only at consolidated level
                </div>
                <Organisational :data="organization" :load="load" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header padding_12_20">
                <div class="d-flex align-items-center">
                  <div class="me-3">
                    <img src="@/assets/images/a/general_affair.svg" />
                  </div>
                  <div>
                    <div class="card_title_1">GENERAL AFFAIRS</div>
                    <div class="card_title_2">
                      Last Updated {{ last_update.general }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body padding_20">
                <!-- <div class="row">
                  <div class="col">
                    <AlertVue :text="alert_general" :type="'danger'" />
                  </div>
                </div> -->
                <General :datas="generalAffairs" :load="load" />
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card">
              <div class="card-header padding_12_20">
                <div class="d-flex align-items-center">
                  <div class="me-3">
                    <img src="@/assets/images/a/legal.svg" />
                  </div>
                  <div>
                    <div class="card_title_1">LEGAL</div>
                    <div class="card_title_2">
                      Last Updated {{ last_update.legal }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body padding_20">
                <!-- <div class="row">
                  <div class="col">
                    <AlertVue :text="alert_legal" :type="'success'" />
                  </div>
                </div> -->
                <Legal :datas="dataLegal" :load="load" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPage from "@/components/HeaderPage.vue";
import Productivity from "../cards/Productivity.vue";
import Excellence from "../cards/Excellence.vue";
import Efficiency from "../cards/Efficiency.vue";
import Occupational from "../cards/Occupational.vue";
import Organisational from "../cards/Organisational.vue";
import General from "../cards/General.vue";
import Legal from "../cards/Legal.vue";
import DropdownGlobal from "@/components/dropdown/DropdownGlobal.vue";
import AlertVue from "@/components/Alert.vue";
// import { toRaw } from "vue";
import ReferenceService from "@/services/reference/reference";
import FinanceService from "@/services/finance/finance";
import LegalService from "@/services/legal/legal";

const getRef = ReferenceService.build();
const getFinance = FinanceService.build();
const apiLegal = LegalService.build();

export default {
  components: {
    HeaderPage,
    Productivity,
    Excellence,
    Efficiency,
    Occupational,
    Organisational,
    General,
    Legal,
    DropdownGlobal,
    AlertVue,
  },

  // computed: {
  //   rawSeries() {
  //     return toRaw(this.series);
  //   },
  // },

  data() {
    return {
      instanceId: "consolidated",
      dataInstance: [],
      alert_human:
        "Indicators for excellence & professionalism, efficiency, and safety are below target - critical to focus in next few weeks",
      alert_general:
        "Revenue from land and building utilization is below target",
      alert_legal:
        "Increased success in legal aid and quicker turnaround for legal opinions",
      load: false,
      header: {
        title: "Few areas for BoD to focus on for HC & Legal:",
        list: [
          "Increasing efficiency for Human Capital cost, safety, and ratios for excellence & professionalism",
          "Meeting target revenue and expenses for general affairs (especially land and building)",
        ],
        image: require("@/assets/images/logo/image_kanan.png"),
        tipe: "multiply",
      },
      last_update: {
        human: "1 Month Ago",
        general: "2 Month Ago",
        legal: "3 Month Ago",
      },
      produtivity: {
        name: "",
        permanent_value: "0",
        permanent_achievement: "0",
        permanent_achievement_status: "UP",
        employee_value: "0",
        employee_trend: "0",
        employee_trend_status: "UP",
        employee_achievement: "0",
        employee_achievement_status: "UP",
        currency: "",
      },
      product: [],
      excellece: {
        female_id: "0",
        female_value: 0,
        female_trend: "0",
        female_trend_status: "UP",
        female_achievement: "0",
        female_achievement_status: "UP",
        female_currency: "",
        millenial_id: "0",
        millenial_value: 0,
        millenial_trend: "0",
        millenial_trend_status: "UP",
        millenial_achievement: "0",
        millenial_achievement_status: "UP",
        millenial_currency: "",
        digital_id: "0",
        digital_value: 0,
        digital_trend: "0",
        digital_trend_status: "UP",
        digital_achievement: "0",
        digital_achievement_status: "UP",
        digital_currency: "",
      },
      excellence: [],
      effeciency: {
        personel_name: "",
        personnel_id: "0",
        personnel_value: 0,
        personnel_trend: "0",
        personnel_trend_status: "UP",
        personnel_achievement: "0",
        personnel_achievement_status: "UP",
        personnel_revenue: "0",
        personal_currency: "",
        pension_id: "0",
        pension_name: "",
        pension_value: 0,
        pension_trend: "0",
        pension_trend_status: "UP",
        pension_achievement: "0",
        pension_achievement_status: "UP",
        pension_revenue: "0",
        pension_currency: "",
      },
      dataEffeciency: [],
      occupational_health: {
        accident_id: "0",
        accident_name: "",
        accident_value: 0,
        accident_trend: "0",
        accident_trend_status: "UP",
        accident_achievement: "0",
        accident_achievement_status: "UP",
        accident_currency: "",
        personal_id: "0",
        personal_name: "",
        personal_value: 0,
        personal_trend: "0",
        personal_trend_status: "UP",
        personal_achievement: "0",
        personal_achievement_status: "UP",
        personal_currency: "",
        contractor_id: "0",
        contractor_name: "",
        contractor_value: 0,
        contractor_trend: "0",
        contractor_trend_status: "UP",
        contractor_achievement: "0",
        contractor_achievement_status: "UP",
        contractor_currency: "",
      },
      occupational: [],
      organisational: {
        hcr_id: "0",
        hcr_name: "",
        hcr_value: 0,
        hcr_trend: "0",
        hcr_trend_status: "UP",
        hcr_achievement: "0",
        hcr_achievement_status: "UP",
        hcr_currency: "",
        ocr_id: "0",
        orc_name: "",
        ocr_value: 0,
        ocr_trend: "0",
        ocr_trend_status: "UP",
        ocr_achievement: "0",
        ocr_achievement_status: "UP",
        ocr_currency: "",
        ohai_id: "0",
        ohai_name: "",
        ohai_value: 0,
        ohai_trend: "0",
        ohai_trend_status: "UP",
        ohai_achievement: "0",
        ohai_achievement_status: "UP",
        ohai_currency: "",
      },
      general_affairs: {
        general_id: "0",
        general_value: 0,
        general_trend: "0",
        general_trend_status: "UP",
        general_achievement: "0",
        general_achievement_status: "UP",
        general_revenue: "0",
        general_currency: "",
        revenue_id: "0",
        revenue_value: 0,
        revenue_trend: "0",
        revenue_trend_status: "UP",
        revenue_achievement: "0",
        revenue_achievement_status: "UP",
        revenue_revenue: "0",
        revenue_currency: "",
      },
      generalAffairs: [],
      legal: {
        legalaid_id: "0",
        legalaid_value: 0,
        legalaid_trend: "0",
        legalaid_trend_status: "UP",
        legalaid_achievement: "0",
        legalaid_achievement_status: "UP",
        legalaid_currency: "",
        turnaround_id: "0",
        turnaround_value: 0,
        turnaround_trend: "0",
        turnaround_trend_status: "UP",
        turnaround_achievement: "0",
        turnaround_achievement_status: "UP",
        turnaround_currency: "",
        settlement_id: "0",
        settlement_value: 0,
        settlement_trend: "0",
        settlement_trend_status: "UP",
        settlement_achievement: "0",
        settlement_achievement_status: "UP",
        settlement_currency: "",
      },
      dataLegal: [],
      organization: [],
    };
  },

  created() {
    this.$store.commit("updateJudulHalaman", "");
    this.getDataHumanCapital();
    this.getDataGeneral();
    this.getDataLegal();
    this.getComboInstance();
    // this.getDataExcellence();
    // this.getDataOrganizational();
    // this.getDataEfficiency();
  },
  watch: {
    instanceId() {
      this.instanceId = this.instanceId;
      this.getDataHumanCapital();
      this.getDataGeneral();
      this.getDataLegal();
    },
  },
  methods: {
    async getComboInstance() {
      const res = await getRef.getRefHolding();
      const data = res.data.data;
      this.dataInstance = data;
    },
    async getDataHumanCapital() {
      let param = Object.assign({
        directorate: this.instanceId,
        year: "2023",
      });
      const res = await apiLegal.getData(param);
      if (res && res.status == 200) {
        let datas = res.data.data;
        let employee = /employee/i;
        let filteredEmployee = datas.filter((obj) =>
          employee.test(obj.metricId)
        );
        let organization = /organi/i;
        let filteredArray = datas.filter((obj) =>
          organization.test(obj.metricId)
        );
        let excellence = /excellence/i;
        let filteredExcellence = datas.filter((obj) =>
          excellence.test(obj.metricId)
        );
        let effeciency = /bpp/i;
        let filteredEffeciency = datas.filter((obj) =>
          effeciency.test(obj.metricId)
        );
        let occupational = /occupational/i;
        let filteredOccupational = datas.filter((obj) =>
          occupational.test(obj.metricId)
        );
        this.occupational = filteredOccupational;
        this.dataEffeciency = filteredEffeciency;
        this.excellence = filteredExcellence;
        this.product = filteredEmployee;
        this.organization = filteredArray;
      }
    },

    async getDataGeneral() {
      let param = Object.assign({
        directorate: this.instanceId,
      });
      const res = await apiLegal.getGeneralAffair(param);
      if (res && res.status == 200) {
        let datas = res.data.data;
        this.generalAffairs = datas;
        datas.forEach((e) => {
          if (e.metricId == "GA_GENERAL") {
            this.general_affairs.general_id = e.id;
            this.general_affairs.general_value = e.value;
            this.general_affairs.general_trend = e.trend;
            this.general_affairs.general_trend_status = e.trendStatus;
            this.general_affairs.general_achievement = e.achievement;
            this.general_affairs.general_achievement_status =
              e.achievementStatus;
            this.general_affairs.general_revenue = e.revenueValue;
          }
          if (e.metricId == "GA_REVENUE") {
            this.general_affairs.revenue_id = e.id;
            this.general_affairs.revenue_value = e.value;
            this.general_affairs.revenue_trend = e.trend;
            this.general_affairs.revenue_trend_status = e.trendStatus;
            this.general_affairs.revenue_achievement = e.achievement;
            this.general_affairs.revenue_achievement_status =
              e.achievementStatus;
            this.general_affairs.revenue_revenue = e.revenueValue;
          }
        });
      }
    },

    async getDataLegal() {
      let param = Object.assign({
        directorate: this.instanceId,
      });
      const res = await apiLegal.getLegal(param);
      if (res && res.status == 200) {
        let datas = res.data.data;
        this.dataLegal = datas;
        datas.forEach((e) => {
          if (e.metricId == "LEGAL_1") {
            this.legal.legalaid_id = e.id;
            this.legal.legalaid_value = e.value;
            this.legal.legalaid_trend = e.trend;
            this.legal.legalaid_trend_status = e.trendStatus;
            this.legal.legalaid_achievement = e.achievement;
            this.legal.legalaid_achievement_status = e.achievementStatus;
          }
          if (e.metricId == "LEGAL_2") {
            this.legal.turnaround_id = e.id;
            this.legal.turnaround_value = e.value;
            this.legal.turnaround_trend = e.trend;
            this.legal.turnaround_trend_status = e.trendStatus;
            this.legal.turnaround_achievement = e.achievement;
            this.legal.turnaround_achievement_status = e.achievementStatus;
          }
          if (e.metricId == "LEGAL_3") {
            this.legal.settlement_id = e.id;
            this.legal.settlement_value = e.value;
            this.legal.settlement_trend = e.trend;
            this.legal.settlement_trend_status = e.trendStatus;
            this.legal.settlement_achievement = e.achievement;
            this.legal.settlement_achievement_status = e.achievementStatus;
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
.sub_title_blue {
  font-size: 14px;
  color: #00a3e9;
  margin-bottom: 8px;
}
</style>
